import { usePageStore } from "@/store";
import { BAHAMAS_MLS_ID } from "@/common/mls";

export const getAgent = async function(store) {
    let page =  usePageStore(this.$pinia)
    let { agentInfo } = this.listingDetail || {};
    if (this.originPriority && agentInfo) {
        store['updateAgentInfo'](agentInfo);
    } else {
        agentInfo = await page.getAgentInfo(this.agentId);
        store['updateAgentInfo'](agentInfo);
    }
};

export function asyncData(store) {
    let ps = [];
    let page =  usePageStore(this.$pinia)
    if (!page.companyInfo) {
        ps.push(page.getCompanyInfo());
    }
    if (this.page?.mlsOrgs?.length && this.page?.mlsOrgs[0]?.id && BAHAMAS_MLS_ID === this.page.mlsOrgs[0].id) {
        ps.push(this.getOfficeStatus());
    }
    ps.push(getAgent.call(this, store));
    return Promise.all(ps);
}
